import { api } from "@/modules/api";
import { AssemblyAiToken } from "@/modules/audio-recording/audio-recording.types";

export const assemblyAiTokenProvider = async (): Promise<AssemblyAiToken> => {
  const response = await api.post("/v2/voice/start_transcription", {
    params: { query: { version: "v3" } },
  });

  const token = response.data?.token;

  if (!token) {
    throw new Error("Failed to fetch AssemblyAI token.");
  }

  return { token };
};
